export default {
  intake: {
    retired: '주문 시스템 수신이 중단되었습니다. 스타일 워크벤치에서 SAP 수신 스타일을 확인해 주세요.',
    eventRestricted: '이 수주회의 수신이 아직 개통되지 않았습니다. 관리자에게 테스트 범위를 확인해 주세요.',
    title: '주문 수신 기록',
    description:
      '최종 주문과 스타일 업무를 확인합니다. 테스트 기간에는 사유와 이력을 남기고 정보를 수정할 수 있습니다.',
    allBrands: '조회 가능한 모든 브랜드',
    search: '스타일 번호 또는 수주회',
    empty: '수신한 주문 결과가 없습니다',
    event: '수주회',
    totalQty: '총 주문 수량',
    state: '수신 상태',
    receivedAt: '수신 일시',
    received: '수신 완료',
    corrected: '수정 완료',
    cancelled: '철회 완료',
    openTask: '스타일 업무 보기',
    testNotice:
      '테스트 기간에는 주문 정보를 수정할 수 있습니다. 저장 후 Tech Pack을 다시 확정해야 하며, 제출 또는 승인된 디자인은 초안으로 돌아갑니다. 재전송은 수동 수정 내용을 덮어쓰지 않습니다.',
    closedNotice:
      '주문 정보는 상위 시스템 결과로 유지됩니다. 변경이 필요하면 상품기획 또는 관리자에게 문의해 주세요.',
    current: '현재 정보',
    original: '원본 수신 정보',
    history: '수정 이력',
    launchMonth: '판매월',
    price: '예상 판매가(CNY)',
    grade: '최종 등급',
    genderBOY: '남성',
    genderGIRL: '여성',
    genderUNISEX: '남녀 공용',
    dimensionsHint:
      '색상 또는 사이즈를 삭제하기 전에 디자인, 자재, 치수 정보에서 사용 중인지 확인합니다. 사용 중인 항목은 관련 정보를 먼저 처리해 주세요.',
    colorNumber: '색상 번호',
    colorCode: '색상 코드',
    colorName: '색상명',
    addColor: '색상 추가',
    sizes: '사이즈',
    quantities: '주문 수량',
    qty: '수량',
    reason: '수정 사유',
    reasonRequired: '사유를 3자 이상 입력해 주세요',
    save: '수정 저장',
    saved: '수정이 저장되었습니다. 안내에 따라 다시 확정해 주세요',
    discard: '저장하지 않은 수정 내용을 버리시겠습니까?',
    noHistory: '수정 이력이 없습니다',
    quantityChanges: '수량 변경 내역 보기',
    before: '수정 전',
    after: '수정 후',
    qtyChange: '총 주문 수량: {before} → {after}',
    cancelTitle: '테스트 수신 철회',
    cancelExplain:
      '철회 대상 스타일: {styles}. 해당 업무는 모두 취소되며 디자인 자료와 원본은 유지됩니다. 확인 후 새 배치로 재전송할 수 있습니다. 철회 사유를 입력해 주세요.',
    cancelConfirm: '이 테스트 수신 철회',
    notConfigured: '주문 연동이 아직 개통되지 않았습니다. 관리자에게 문의해 주세요',
    keyInvalid: '수신 인증 정보가 유효하지 않습니다. 연동 설정을 확인해 주세요',
    invalid: '주문 정보 확인에 실패했습니다. 상위 시스템에서 수정 후 다시 전송해 주세요',
    batchMismatch: '전송 배치 번호가 일치하지 않습니다',
    batchConflict: '사용된 배치의 내용을 변경할 수 없습니다',
    snapshotConflict:
      '같은 확정 기록의 내용이 변경되었습니다. 확인하거나 테스트 수신을 철회한 후 다시 전송해 주세요',
    cancelledRetry: '철회된 테스트 수신입니다. 새 배치로 다시 전송해 주세요',
    checkExpired: '확인 결과가 만료되었거나 담당자가 변경되었습니다. 다시 확인 후 전송해 주세요',
    notFound: '주문 수신 기록을 찾을 수 없습니다',
    changed: '다른 사용자가 수정했습니다. 새로고침 후 확인해 주세요',
    correctionClosed: '테스트 정보 수정이 종료되었습니다',
    dimensionInUse:
      '삭제할 색상 또는 사이즈가 사용 중입니다. 관련 디자인, 자재, 치수 정보를 먼저 처리해 주세요',
    externalTransfer:
      'SAP로 전송되었거나 전송 중인 자료는 직접 수정하거나 테스트 수신을 철회할 수 없습니다',
    rateLimit: '요청이 많습니다. 잠시 후 다시 시도해 주세요',
    field: {
      styleName: '스타일명',
      productYear: '제품 연도',
      season: '시즌',
      launchMonth: '판매월',
      tagPrice: '예상 판매가(CNY)',
      finalGrade: '최종 등급',
    },
  },
};
